import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { LockKeyhole } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { saveSession } from "@/lib/auth";
import { LogoMark } from "@/lib/Logo";
import { BRAND } from "@/lib/constants";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      saveSession(data.token, data.user);
      navigate(data.user.role === "guest" ? "/account" : "/admin");
    } catch (e) {
      setError(formatApiError(e.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-page">
      <form className="login-card" onSubmit={handleSubmit} data-testid="admin-login-form">
        <LogoMark size={44} />
        <h1>{BRAND}</h1>
        <p className="login-sub">Owner inbox · secure sign in</p>
        <label>
          Email
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" data-testid="admin-login-email-input" />
        </label>
        <label>
          Password
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" data-testid="admin-login-password-input" />
        </label>
        {error && (
          <div className="login-error" data-testid="admin-login-error">
            {error}
          </div>
        )}
        <button className="button button-gold" type="submit" disabled={loading} data-testid="admin-login-submit-button">
          <LockKeyhole size={16} /> {loading ? "Signing in…" : "Sign in"}
        </button>
        <Link to="/" className="login-back" data-testid="back-to-site-link">
          ← Back to website
        </Link>
      </form>
    </div>
  );
}
